import { useEffect } from 'react';
import { stripHtml } from '@client/utils/stripHtml';

/**
 * Sets document.title, <meta name="description">, and breadcrumb header reactively.
 * Strips HTML from values (entity names may come from RichTextFields).
 * Cleans up on unmount.
 */
export const usePageMeta = ({ title, description, breadcrumbTitle, breadcrumbDescription } = {}) => {
  useEffect(() => {
    if (title) document.title = stripHtml(title);
    return () => {
      document.title = 'SAgE pesticides';
    };
  }, [title]);

  useEffect(() => {
    const meta = document.querySelector('meta[name="description"]');
    if (meta && description) meta.setAttribute('content', stripHtml(description));
    return () => {
      const meta = document.querySelector('meta[name="description"]');
      if (meta) meta.setAttribute('content', '');
    };
  }, [description]);

  // Replace skeleton title with i18n text
  useEffect(() => {
    const staticTitle = document.getElementById('static-title');
    if (staticTitle && breadcrumbTitle) {
      staticTitle.innerHTML = stripHtml(breadcrumbTitle);
    }
  }, [breadcrumbTitle]);

  // Replace skeleton description with i18n text
  useEffect(() => {
    const staticDesc = document.getElementById('static-description');
    if (staticDesc && breadcrumbDescription) {
      staticDesc.innerHTML = breadcrumbDescription;
      staticDesc.classList.remove('space-y-2');
    }
  }, [breadcrumbDescription]);
};
